module.exports = __webpack_public_path__ + "static/img/3_2_2.c2135894.jpg";